export const PERIOD_OPTION_KEYS = [
  { value: 'all', key: 'allTime' },
  { value: 'today', key: 'today' },
  { value: 'yesterday', key: 'yesterday' },
  { value: 'this_week', key: 'thisWeek' },
  { value: 'this_month', key: 'thisMonth' },
  { value: 'last_month', key: 'lastMonth' },
  { value: 'this_year', key: 'thisYear' },
  { value: 'last_year', key: 'lastYear' },
  { value: 'custom', key: 'custom' },
];

export const buildMaputoRangeBoundary = (dateValue, boundary = 'start') => {
  if (!dateValue) return null;
  return `${dateValue}T${boundary === 'end' ? '23:59:59.999' : '00:00:00.000'}+02:00`;
};

export const formatSelectedDateRangeLabel = (startDate, endDate, locale) => {
  if (!startDate || !endDate) return '';
  const start = new Date(`${startDate}T00:00:00+02:00`);
  const end = new Date(`${endDate}T00:00:00+02:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return '';
  return `${start.toLocaleDateString(locale)} - ${end.toLocaleDateString(locale)}`;
};

export const buildTranslatedPeriodOptions = (translatePeriod) => (
  PERIOD_OPTION_KEYS.map((option) => ({
    ...option,
    label: translatePeriod(option.key),
  }))
);

export const normalizeDateFilterValue = (value) => {
  if (!value) return '';
  const text = String(value).trim();
  if (!text) return '';
  return text.includes('T') ? text.split('T')[0] : text;
};